// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  ApierrorsError,
  RequestEnvironmentConfig,
  ResponseEnvironmentConfig,
  ResponseEnvironmentConfigList,
} from '../models/index';
import {
  ApierrorsErrorFromJSON,
  ApierrorsErrorToJSON,
  RequestEnvironmentConfigFromJSON,
  RequestEnvironmentConfigToJSON,
  ResponseEnvironmentConfigFromJSON,
  ResponseEnvironmentConfigToJSON,
  ResponseEnvironmentConfigListFromJSON,
  ResponseEnvironmentConfigListToJSON,
} from '../models/index';

export interface V3ConfigsConfigNameDeleteRequest {
  configName: string;
}

export interface V3ConfigsConfigNameGetRequest {
  configName: string;
}

export interface V3ConfigsConfigNamePutRequest {
  configName: string;
  config: RequestEnvironmentConfig;
}

/**
 *
 */
export class ConfigurationApi extends runtime.BaseAPI {
  /**
   * Delete a saved configuration
   * Delete a saved configuration
   */
  async v3ConfigsConfigNameDeleteRaw(
    requestParameters: V3ConfigsConfigNameDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['configName'] == null) {
      throw new runtime.RequiredError(
        'configName',
        'Required parameter "configName" was null or undefined when calling v3ConfigsConfigNameDelete().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/v3/configs/{configName}`.replace(
          `{${'configName'}}`,
          encodeURIComponent(String(requestParameters['configName'])),
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a saved configuration
   * Delete a saved configuration
   */
  async v3ConfigsConfigNameDelete(
    requestParameters: V3ConfigsConfigNameDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.v3ConfigsConfigNameDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Get a saved configuration
   * Get a saved configuration
   */
  async v3ConfigsConfigNameGetRaw(
    requestParameters: V3ConfigsConfigNameGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseEnvironmentConfig>> {
    if (requestParameters['configName'] == null) {
      throw new runtime.RequiredError(
        'configName',
        'Required parameter "configName" was null or undefined when calling v3ConfigsConfigNameGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/v3/configs/{configName}`.replace(
          `{${'configName'}}`,
          encodeURIComponent(String(requestParameters['configName'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseEnvironmentConfigFromJSON(jsonValue),
    );
  }

  /**
   * Get a saved configuration
   * Get a saved configuration
   */
  async v3ConfigsConfigNameGet(
    requestParameters: V3ConfigsConfigNameGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseEnvironmentConfig> {
    const response = await this.v3ConfigsConfigNameGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Upsert saved configurations
   * Upsert saved configurations
   */
  async v3ConfigsConfigNamePutRaw(
    requestParameters: V3ConfigsConfigNamePutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['configName'] == null) {
      throw new runtime.RequiredError(
        'configName',
        'Required parameter "configName" was null or undefined when calling v3ConfigsConfigNamePut().',
      );
    }

    if (requestParameters['config'] == null) {
      throw new runtime.RequiredError(
        'config',
        'Required parameter "config" was null or undefined when calling v3ConfigsConfigNamePut().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/v3/configs/{configName}`.replace(
          `{${'configName'}}`,
          encodeURIComponent(String(requestParameters['configName'])),
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: RequestEnvironmentConfigToJSON(requestParameters['config']),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Upsert saved configurations
   * Upsert saved configurations
   */
  async v3ConfigsConfigNamePut(
    requestParameters: V3ConfigsConfigNamePutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.v3ConfigsConfigNamePutRaw(requestParameters, initOverrides);
  }

  /**
   * List saved configurations
   * List saved configurations
   */
  async v3ConfigsGetRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseEnvironmentConfigList>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/v3/configs`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseEnvironmentConfigListFromJSON(jsonValue),
    );
  }

  /**
   * List saved configurations
   * List saved configurations
   */
  async v3ConfigsGet(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseEnvironmentConfigList> {
    const response = await this.v3ConfigsGetRaw(initOverrides);
    return await response.value();
  }
}
